import React from 'react';
import { motion } from 'framer-motion';
export const Terms = () => {
  return <div className="bg-white" data-id="element-497">
      <section className="py-16 md:py-24 bg-gradient-to-b from-white to-brand-light" data-id="element-498">
        <div className="container-custom" data-id="element-499">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5
        }} className="text-center max-w-3xl mx-auto" data-id="element-500">
            <h1 className="text-4xl md:text-5xl font-bold text-brand-blue mb-6" data-id="element-501">
              Terms & Conditions
            </h1>
            <p className="text-gray-600" data-id="element-502">
              Last updated: {new Date().toLocaleDateString('en-GB')}
            </p>
          </motion.div>
        </div>
      </section>
      <section className="py-16 bg-white" data-id="element-503">
        <div className="container-custom max-w-4xl" data-id="element-504">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="prose prose-lg max-w-none" data-id="element-505">
            <h2 className="text-2xl font-bold text-brand-blue mb-4" data-id="element-506">
              Agreement to Terms
            </h2>
            <p className="text-gray-600 mb-6" data-id="element-507">
              By accessing or using Daily Serve, you agree to be bound by these
              Terms and Conditions. If you disagree with any part of these
              terms, you may not access the service.
            </p>
            <h2 className="text-2xl font-bold text-brand-blue mb-4 mt-8" data-id="element-508">
              Use Licence
            </h2>
            <p className="text-gray-600 mb-4" data-id="element-509">
              Permission is granted to use Daily Serve for commercial and
              personal purposes under the following conditions:
            </p>
            <ul className="list-disc pl-6 text-gray-600 mb-6" data-id="element-510">
              <li data-id="element-511">You must maintain an active, paid licence</li>
              <li data-id="element-512">You may not modify or copy the software</li>
              <li data-id="element-513">You may not attempt to reverse engineer the platform</li>
              <li data-id="element-514">You may not remove any copyright or proprietary notices</li>
              <li data-id="element-515">
                You may not transfer the software to another person or entity
              </li>
            </ul>
            <h2 className="text-2xl font-bold text-brand-blue mb-4 mt-8" data-id="element-516">
              User Accounts
            </h2>
            <p className="text-gray-600 mb-6" data-id="element-517">
              You are responsible for maintaining the confidentiality of your
              account and password. You agree to accept responsibility for all
              activities that occur under your account. We reserve the right to
              refuse service, terminate accounts, or remove content at our sole
              discretion.
            </p>
            <h2 className="text-2xl font-bold text-brand-blue mb-4 mt-8" data-id="element-518">
              Payment Terms
            </h2>
            <p className="text-gray-600 mb-6" data-id="element-519">
              All payments are processed securely through our payment provider.
              One-time payments grant lifetime access to the platform at the
              purchased tier level. We offer a 30-day money-back guarantee for
              all purchases.
            </p>
            <h2 className="text-2xl font-bold text-brand-blue mb-4 mt-8" data-id="element-520">
              Acceptable Use
            </h2>
            <p className="text-gray-600 mb-4" data-id="element-521">
              You agree not to use Daily Serve to:
            </p>
            <ul className="list-disc pl-6 text-gray-600 mb-6" data-id="element-522">
              <li data-id="element-523">Violate any laws or regulations</li>
              <li data-id="element-524">Infringe on intellectual property rights</li>
              <li data-id="element-525">Transmit malicious code or viruses</li>
              <li data-id="element-526">Harass, abuse, or harm others</li>
              <li data-id="element-527">Attempt to gain unauthorised access to the platform</li>
            </ul>
            <h2 className="text-2xl font-bold text-brand-blue mb-4 mt-8" data-id="element-528">
              Limitation of Liability
            </h2>
            <p className="text-gray-600 mb-6" data-id="element-529">
              Daily Serve shall not be liable for any indirect, incidental,
              special, consequential, or punitive damages resulting from your
              use or inability to use the service.
            </p>
            <h2 className="text-2xl font-bold text-brand-blue mb-4 mt-8" data-id="element-530">
              Changes to Terms
            </h2>
            <p className="text-gray-600 mb-6" data-id="element-531">
              We reserve the right to modify these terms at any time. We will
              notify users of any material changes via email or through the
              platform.
            </p>
            <h2 className="text-2xl font-bold text-brand-blue mb-4 mt-8" data-id="element-532">
              Contact Information
            </h2>
            <p className="text-gray-600" data-id="element-533">
              For questions about these Terms, please contact us at{' '}
              <a href="mailto:rapeezshrestha385@gmail.com" className="text-brand-teal hover:text-brand-blue" data-id="element-534">
                rapeezshrestha385@gmail.com
              </a>
            </p>
          </motion.div>
        </div>
      </section>
    </div>;
};